import * as React from 'react';
import { ContentSection } from '../../../components/Layout/ContentSection';
import { GenerateInvoiceForInvoiceCollection } from './GenerateInvoiceForInvoiceCollection';
import { InvoiceList } from '../../../views/InvoiceList/InvoiceList';
import { useGetPartnerInvoicesForInvoiceCollectionQuery } from '../../../graphql/queries/getPartnerInvoicesForInvoiceCollection.generated';
import { InvoiceCollectionDetailFragment } from '../../../graphql/fragments/invoiceCollectionDetail.generated';
import i18n from '@/utils/i18n';

type InvoiceCollectionInvoicesTabProps = {
  invoiceCollectionId: string;
  invoiceCollection: InvoiceCollectionDetailFragment;
};

export const InvoiceCollectionInvoicesTab: React.FC<
  InvoiceCollectionInvoicesTabProps
> = ({ invoiceCollectionId, invoiceCollection }) => {
  const { loading: loadingInvoices, data: invoices } =
    useGetPartnerInvoicesForInvoiceCollectionQuery({
      variables: { invoice_collection_id: invoiceCollectionId },
    });

  return (
    <ContentSection
      title={i18n.t('InvoiceCollection:invoices')}
      collapsable={false}
    >
      <GenerateInvoiceForInvoiceCollection
        invoiceCollectionId={invoiceCollectionId}
      />

      <br />

      <InvoiceList
        allowedToAccess={true}
        invoiceTag={invoiceCollectionId}
        invoices={
          [...(invoices?.getPartnerInvoicesForInvoiceCollection || [])].sort(
            (a, b) =>
              new Date(b.date || 0).getTime() - new Date(a.date || 0).getTime(),
          ) || []
        }
        loading={loadingInvoices}
        setInvoices={() => {}}
        currencySymbol={
          invoiceCollection.stores.find(() => true)?.currency_symbol
        }
      />
    </ContentSection>
  );
};
